import React from 'react';
import { Typography } from '../../../../components';
import { PublicLinkItemData } from '../types';
import { getCampaignId } from '../utils';
import { useTranslations } from '../../../../contexts/translation.context';
import { LinkIcon } from '../../../../components/icons';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Avatar, Chip } from '@heroui/react';
import { getFilterIcon, transformPlatform } from '../../../../utils/platformUtils';

interface AccountCellProps {
  item: PublicLinkItemData;
}

const AccountCell: React.FC<AccountCellProps> = ({ item }) => {
  const { t } = useTranslations();
  const campaignId = getCampaignId(item.model.link);
  const platformName = transformPlatform(item.source);
  const platformIcon = getFilterIcon(item.source, 14);

  const popularityPercent = item.model.of_data?.overall_popularity_percent;
  const subscriptionType =
      item?.model?.type === 'free'
        ? 'FREE'
        : item?.model?.type === 'free_trial' || item?.model?.type === 'free-trial' || item?.model?.type === 'paid' || item?.model?.type === 'free trial'
          ? 'Free-Trial'
          : 'FREE';
  return (
    <div className="flex gap-4 items-start w-full">
      <Avatar
        src={item?.model?.avatar}
        showFallback
        name={item.model.of_user_name?.slice(0, 1)}
        className="w-8 h-8 rounded-2"
      />

      <div className="flex flex-col gap-1 items-start justify-center">
        {/* Row 1: ID, Campaign, Username, Commission */}
        <div className="flex gap-2 items-center">
          <Typography variant="body2" className="text-auth-ink">
            #{item._id.slice(-4)}
          </Typography>
          <Typography variant="label2" className="text-auth-ink">
            {campaignId.slice(-4)}
          </Typography>
          <button className="text-partner text-sm font-normal">@{item.model.of_user_name}</button>
          <Chip
            variant="flat"
            size="sm"
            className="bg-[rgba(0,111,238,0.2)] text-partner rounded-full px-1 h-6"
          >
            <span className="text-xs leading-4">{subscriptionType}</span>
          </Chip>
          {typeof popularityPercent === 'number' && !Number.isNaN(popularityPercent) && (
            <div className="bg-[rgba(245,165,36,0.2)] flex h-6 items-center justify-center px-1 rounded-[9999px]">
              <Typography variant="body3" className="text-warning px-1">
                {popularityPercent}%
              </Typography>
            </div>
          )}
        </div>

        {/* Row 2: Source chip and campaign type */}
        <div className="flex gap-2 items-center">
          <div className="bg-[rgba(120,40,200,0.2)] flex h-6 items-center justify-center px-1 rounded-[9999px]">
            <Typography variant="body3" className="text-accent px-1">
              {item.model.type} {new Date(item.created_at).toLocaleDateString('ru-RU')}
            </Typography>
          </div>
          <div className="flex gap-2 items-center">
            <div className="border-[1.4px] border-solid border-zinc-300 flex gap-1 h-6 items-center justify-center px-1 rounded-3.5">
              <div className="flex gap-0.5 items-center justify-center px-1">
                {platformIcon}
                <Typography variant="body3" className="text-auth-ink">
                  {platformName}
                </Typography>
              </div>
            </div>
            {/* <Typography variant="label3SemiBold" className="text-auth-ink">
              {t('partner.orders.byCampaign')}
            </Typography> */}
          </div>
        </div>

        {/* Row 3: Link */}
        <div className="flex gap-1 items-center">
          <a
            href={item.model.link}
            target="__blank"
            className="flex items-center gap-1 bg-husky rounded-full px-2 py-1"
          >
            <LinkIcon size={18} fill="#006FEE" className="text-partner" />
            <Typography variant="body2" className="!text-partner truncate max-w-48">
              {item.model.link}
            </Typography>
          </a>
          <div className="flex gap-1 items-center">
            <Icon icon="solar:eye-bold" width={16} height={16} className="text-default-400" />
            <Typography variant="label3" className="text-auth-muted">
              {item.transitions_count || 0}
            </Typography>
            {typeof item.subscribed_count === 'number' && (
              <Typography variant="label3" className="text-neutral-8">
                ({item.transitions_count ? Math.round((item.subscribed_count / item.transitions_count) * 100) : 0}%)
              </Typography>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountCell;
